import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import WishlistForm from 'components/domain/wishlist/WishlistForm';
import { useFdrWishlistRenameWishlistMutation } from 'fdr/schemas/mutation/wishlist/fdr-wishlist-rename-wishlist.generated';

const WishlistFormWrapper = styled.div(
  sx2CssThemeFn({
    px: 0,
    pb: [4, '65px'],
  })
);

const WishlistEditFormContainer: React.FC<{
  id: string;
  value: string;
  onSubmit: () => void;
  onClose: () => void;
}> = ({ id, value, onSubmit, onClose }) => {
  const [t] = useTranslation(['wishlist']);

  const [renameWishlist] = useFdrWishlistRenameWishlistMutation({
    refetchQueries: [`FdrWishlistOverview`],
  });

  const onHandleSubmit = async (name: string) => {
    try {
      renameWishlist({
        variables: {
          input: {
            name,
            wishlistId: id,
          },
        },
      });
      onSubmit();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Rename wishlist query failure`, e);
    }
  };

  return (
    <WishlistFormWrapper>
      <WishlistForm
        value={value}
        canToggle={false}
        submitBtnText={t('wishlist:editWishlist.submit.button')}
        onClose={onClose}
        onSubmit={onHandleSubmit}
      />
    </WishlistFormWrapper>
  );
};

export default WishlistEditFormContainer;
